import { Component } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CompressionService } from '../compression.service';

@Component({
  selector: 'app-word-decompression',
  templateUrl: './word-decompression.component.html',
  styleUrls: ['./word-decompression.component.css']
})
export class WordDecompressionComponent extends GeneralExerciseComponent {

  text: string;
  compressedText: string;

  errors: number[] = [];

  highlight: boolean;

  toHighlight: number[] = [];
  caretPosition: number;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected compressionService: CompressionService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.compressedText = this.configuration.typespecifics.compressedText;
    this.highlight = this.configuration.typespecifics.highlight;

    this.text = "";
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.text) {
        this.text = this.state.typespecific.text;
      }
    }
  }

  computeState() {
    this.state.typespecific.text = this.text;
  }

  checkSolution() {
    let solution = this.compressionService.decompress(this.compressedText);
    let studentSolution = this.text.split(" ");
    this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]);

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  evaluate(): number[] {
    let solution = this.compressionService.decompress(this.compressedText);
    let studentSolution = this.text.split(" ");
    let errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]);

    let points = 1;
    if (this.compressedText.includes("+") && !this.compressedText.includes("#")) {
      points = 2;
    } else if (this.compressedText.includes("+") && this.compressedText.includes("#")) {
      points = 3;
    }
    return [(solution.split(" ").length - errors.length) / solution.split(" ").length * points, points];
  }

  /** compute the words to highlight */
  setCaret(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPosition = oField.selectionStart;
    }
    let index = this.text.substr(0, this.caretPosition).split(" ").length - 1;
    this.toHighlight = [];
    this.computeHightlight(index);
  }

  /** recursively compute the words to highlight */
  computeHightlight(index: number) {
    let wordsToHighlight: number[] = [index];
    let currentWord = this.compressedText.split(" ")[index];
    let allWords = this.compressedText.split(" ");

    if (currentWord == undefined) {
      return;
    }
    let pieces = currentWord.split(/([#+])/);
    let lastSign = "";
    for (let p of pieces) {
      if (p.charAt(0) == "+" || p.charAt(0) == "#") {
        lastSign = p;
      } else {
        if (lastSign != "") {
          let number = "";
          for (let i = 0; i < p.length; i++) {
            if (!Number.isNaN(+p.charAt(i))) {
              number = number.concat(p.charAt(i));
            }
          }
          if (lastSign == "#") {
            wordsToHighlight.push(+number - 1);
            if (allWords[+number - 1].includes("#") || allWords[+number - 1].includes("+")) {
              this.computeHightlight(+number - 1);
            }
          } else {
            wordsToHighlight.push(index - +number);
            if (allWords[index - +number].includes("#") || allWords[index - +number].includes("+")) {
              this.computeHightlight(index - +number);
            }
          }
        }
        lastSign = "";
      }
    }

    //if there are still compressions, redo the work
    for (let w of wordsToHighlight) {
      let start = allWords.slice(0, w).join(" ").length;
      start = start ? start + 1 : 0;
      for (let i = start; i < allWords.slice(0, w + 1).join(" ").length; i++) {
        this.toHighlight.push(i);
      }
    }
  }

  /** is the given word errorneous? */
  inError(i: number) {
    let index = this.compressedText.slice(0, i).split(" ").length - 1;
    return this.errors.includes(index);
  }
  
  /** normalize the text */
  normalizeText() {
    this.text = this.text.replace(/[^A-z ]/gi, '').replace(/\s+/, " ").toUpperCase();
  }

}
